<template>

</template>

<script>

    import qs from "qs";

    export default {
        name: "PolicyLink",
        ata() {
            return {}
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            }
        },
        mounted() {
            const vm = this;

            $("#header").hide();
            $("#footer").hide();

            var params = {
                cntryCode: _domainCntryCode,
                langCode: _domainLangCode,
                termsType: 'PRV'
            };

            this.$axios.post('/api/terms/retrieveTermsUrl.ajax', qs.stringify(params)).then((result) => {
                window.location.href = result.data.termsUrl;
            }).catch((err) => {
                alert(err);
            });
        }
    }
</script>

<style scoped>

</style>